import { Link } from "react-router-dom";
import { getImageSrc } from "../utils/getImageSrc";
import LazyImage from "../components/ui/LazyImage";
import logo from "../assets/images/green-logo.png";
import { highlightText } from "../utils/TextHighLighter";

interface ManagerCardProps {
  person: any;
  index: number;
  isActive: boolean;
  searchQuery: string;
  onClick: (index: number) => void;
}

export default function ManagerCard({
  person,
  index,
  isActive,
  searchQuery,
  onClick,
}: ManagerCardProps) {
  const personLogo = getImageSrc(
    person.logo,
    person.cover,
    person.image,
    person.avatar,
    person.extra
  );

  return (
    <Link
      to={`/managers/${person.id}`}
      onClick={() => onClick(index)}
      className={`flex items-center justify-start group xl:max-w-full h-[90px] border hover:border-complement-03 gap-x-2.5 p-2.5 transition-all duration-300 cursor-pointer shadow-sm rounded-[20px] min-w-0 ${
        isActive
          ? "bg-green-02 text-white shadow-lg border-green-04/15"
          : "bg-white text-green-05 hover:bg-green-02 border group-hover:text-green-05 group-hover:border-green-02 group-hover:border"
      }`}
    >
      <div className="flex items-center gap-x-2.5 text-right w-full">
        <div className="size-[70px] bg-white shrink-0 border border-green-04 group-hover:border-white shadow-sm overflow-hidden rounded-full">
          <LazyImage
            src={personLogo || logo}
            alt={person.name || person.nickname || "profile"}
            className={`h-full w-full text-xs text-center ${
              personLogo ? "object-cover" : "object-contain"
            }`}
          />
        </div>
        <div className="flex flex-col items-start justify-between space-y-[2.5px] w-full font-estedad">
          <h4 className="text-[11px] text-green-04 font-medium w-full truncate max-w-[90%]">
            {highlightText(person.nickname || "", searchQuery)}
          </h4>
          <h5 className="text-[15px] font-bold text-green-05">
            {highlightText(person.name || "", searchQuery)}
          </h5>
          <p className="text-[11px] font-medium text-green-04">
            {highlightText(person.position || person.layout || "", searchQuery)}
          </p>
        </div>
      </div>
    </Link>
  );
}